import { formatUnit } from '@/utils';
export default {
    props: {
        source: {
            type: Object,
            default: function() {
                return {};
            },
        },
        plateBasicInfo: {
            type: Object,
            default: () => {},
        },
        plateStatus: {
            type: Object,
            default: () => {},
        },
        plateDyna: {
            type: Object,
            default: () => {},
        },
        plateStatistics: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            openPanel: false,
        };
    },
    computed: {
        getPanelType() {
            if (!this.openPanel) return '';
            return 'panel-full';
        },
    },
    filters: {},
    async mounted() {},
    methods: {
        formatUnit: formatUnit,
        getUnitNum(num) {
            return num > 0 ? '+' + num : num;
        },
        getColor(val, base) {
            base = base === undefined ? this.plateStatistics.PreClosePrice : base;
            let f = val - base;
            if (f > 0) return 'rise-color';
            if (f < 0) return 'fall-color';
            return 'draw-color';
        },
    },
};
